import { toPairs } from 'lodash';

export default function getScreenerUrl(params) {
  const queryString = toPairs(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return queryString ? `${UPSOLVE_FILER_URL}/screener?${queryString}` : UPSOLVE_FILER_URL;
}